var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"ma-0 pt-1"},[_c('span',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.params.data.employee))])])}
var staticRenderFns = []

export { render, staticRenderFns }